<template>
    <v-navigation-drawer
        :mini-variant.sync="mini"
        app
        class="elevation-1 darken-4 blue-grey main-sidebar translateY-zero"
        dark
        fixed
        id="appDrawer"
        v-if="drawer"
        width="260"
    >
        <v-toolbar color="darken-4 blue-grey" dark style="padding-left: 40px">
            <img alt="Cibes admin dashboard" height="34" v-bind:src="computeLogo">
        </v-toolbar>
        <vue-perfect-scrollbar :settings="scrollSettings" class="drawer-menu--scroll">
            <v-list dense expand>
                <template v-for="(item, i) in menus">
                    <!--group with subitems-->
                    <v-list-group
                        :group="item.group"
                        :key="item.name"
                        :prepend-icon="item.icon"
                        no-action="no-action"
                        v-if="item.items && (!item.page_admin || (item.page_admin && isAdmin) || (item.page_admin && isSupperAdmin)) "
                    >
                        <v-list-tile ripple="ripple" slot="activator">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <template v-for="(subItem, i) in item.items">
                            <!--sub group-->
                            <v-list-group
                                :group="subItem.group"
                                :key="subItem.name"
                                sub-group="sub-group"
                                v-if="subItem.items"
                            >
                                <v-list-tile ripple="ripple" slot="activator">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile
                                    :href="grand.href"
                                    :key="i"
                                    :to="genChildTarget(item, grand)"
                                    ripple="ripple"
                                    v-for="(grand, i) in subItem.children"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                            <!--child item-->
                            <v-list-tile
                                :disabled="subItem.disabled"
                                :href="subItem.href"
                                :key="i"
                                :target="subItem.target"
                                :to="genChildTarget(item, subItem)"
                                ripple="ripple"
                                v-else
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        <span>{{ subItem.title }}</span>
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.action">
                                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </template>
                    </v-list-group>
                    <v-subheader :key="i" v-else-if="item.header">{{ item.header }}</v-subheader>
                    <v-divider :key="i" v-else-if="item.divider"></v-divider>
                    <!--top-level link-->
                    <v-list-tile
                        :disabled="item.disabled"
                        :href="item.href"
                        :key="item.name"
                        :target="item.target"
                        :to="!item.href ? { name: item.name } : null"
                        rel="noopener"
                        ripple="ripple"
                        v-else-if="!item.page_admin || (item.page_admin && isAdmin) || (item.page_admin && isSupperAdmin)"
                    >
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="item.subAction">
                            <v-icon class="success--text">{{ item.subAction }}</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import menu from "@/config/menu";
export default {
    name: "app-drawer",
    components: {
        VuePerfectScrollbar
    },
    props: {
        expanded: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        mini: false,
        menus: menu,
        scrollSettings: {
            maxScrollbarLength: 160
        }
    }),
    computed: {
        computeGroupActive() {
            return true;
        },
        computeLogo() {
            return "/images/logo.png";
        },
        isAdmin() {
            let user = this.$store.getters["auth/currentUser"];
            return user ? user.user_type === 3 : false;
        },
        isSupperAdmin() {
            let user = this.$store.getters["auth/currentUser"];
            return user ? (user.user_type === 4) : false;
        },
        drawer() {
            return this.$store.getters["common/getDrawerTogged"];
        },
        sideToolbarColor() {
            return this.$vuetify.options.extra.sideNav;
        }
    },

    methods: {
        genChildTarget(item, subItem) {
            if (subItem.href) return;
            if (subItem.component) {
                return {
                    name: subItem.component
                };
            }
            return { name: `${item.group}/${subItem.name}` };
        }
    }
};
</script>


<style lang="stylus">
#appDrawer {
    overflow: hidden;

    .drawer-menu--scroll {
        height: calc(100vh - 48px);
        overflow: auto;
    }
}
    .drawer-menu--scroll .v-list a:hover .v-icon {
        color #2A353B;
    }
    .drawer-menu--scroll .v-list a:hover .v-list__tile__content {
        color #2A353B;
    }
    .drawer-menu--scroll .v-list .v-list__tile__content {
        font-size 14px;
    }
    .translateY-zero{
        transform: translateY(0) !important
    }
</style>
